/**
 *  职位
 */

const Post = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/post");

const PostDetail = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/detail");

const PostDetail2 = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/detail2");

const PostEdit = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/postEdit");

  const PostNew = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/postNew");

  const PostSuccess = () =>
  import(/* webpackChunkName: "post" */ "@/app/admin/post/postSuccess");

const PostPreview = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/postPreview");
const HunterPost = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/hunterPost");
const FlexiblePost = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/flexiblePost");
const MoneyTask = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/jobTask/jobTask");
const moneyTaskDetail = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/jobTask/jobTaskDetail");
const PostMoneyTask = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/jobTask/postJobTask");
const PublishTask = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/jobTask/publish-task");
const FullTimeCreate = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/fullTime/create");
const FullTimeSupplement= () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/fullTime/supplement");
const FullTimeService = () => import(/* webpackChunkName: "resume" */ "@/app/admin/post/fullTime/postService");

export default [
  {
    path: "post-create",
    name: "create",
    component: FullTimeCreate,
    meta: { title: '发布全职职位', key: "post", keepAlive: true }
  },
  {
    path: "post-money-task",
    name: "moneytask",
    component: PostMoneyTask,
    meta: { title: '发布赚钱任务', key: "money-task" }
  },
  {
    path: "post-supplement",
    name: "supplement",
    component: FullTimeSupplement,
    meta: { title: '发布全职职位', key: "post"}
  },
  {
    path: "post-service",
    name: "fullTimeService",
    component: FullTimeService,
    meta: { title: '发布全职职位', key: "post"}
  },
  {
    path: "post",
    name: "post",
    component: Post,
    meta: { title: "企业全职", key: "post", permission: "job_manager" }
  },
  {
    path: "hunter-post",
    name: "hunterPost",
    component: HunterPost,
    meta: { title: "猎头职位", key: "hunter-post" }
  },
  {
    path: "flexible-post",
    name: "flexiblePost",
    component: FlexiblePost,
    meta: { title: "灵活用工", key: "flexible-post" }
  },
  {
    path: "money-task",
    name: "moneyTask",
    component: MoneyTask,
    meta: { title: "赚钱任务", key: "money-task" }
  },
  {
    path: "money-task/detail/:id",
    name: "moneyTaskDetail",
    component: moneyTaskDetail,
    meta: { title: "赚钱任务-详情", key: "moneyTask" }
  },
  {
    path: "jobTask/publish-task",
    name: "publishTask",
    component: PublishTask,
    meta: { title: "发布任务", key: "money-task" }
  },
  {
    path: "post-detail/:post_id",
    component: PostDetail,
    meta: {
      title: "职位详情",
      key: "post",
      permission: "job_manager.job_list.btn_look_up"
    }
  },
  {
    path: "post-detail2/:post_id",
    component: PostDetail2,
    meta: {
      title: "职位详情",
      key: "post",
      permission: "job_manager.job_list.btn_look_up"
    }
  },
  {
    path: "post-new",
    component: PostNew,
    meta: {
      title: "发布职位",
      key: "post-edit",
      permission: "job_manager.job_list.btn_list_edit",
    },
  },
  {
    path: "post-success",
    component: PostSuccess,
    meta: {
      title: "发布成功",
      type: "fill",
      key: "post-success",
      permission: "job_manager.job_list.btn_look_up"
    },
  },

  
  {
    path: "post-edit",
    name: "post-edit",
    component: PostEdit,
    meta: {
      title: "职位管理",
      key: "hunter-post",
      permission: "job_manager.job_list.btn_list_edit",
      keepAlive: true
    }
  },
  {
    path: "post-preview",
    name: "post-preview",
    component: PostPreview,
    meta: { title: "职位管理", key: "post", permission: "job_manager" }
  }
];
